import useCustomersStore from '@/store/customers';
import useCustomerStore from '@/store/customer';
import useUsersStore from '@/store/users';
import useNotificationStore from '@/store/notifications';
import useCallcenterStore from '@/store/callcenter';

const useClearState = () => {
  const { clearState: clearCustomersState } = useCustomersStore();
  const { clearState: clearCustomerState } = useCustomerStore();
  const { clearState: clearUsersState } = useUsersStore();
  const { clearState: clearNotificationsState } = useNotificationStore();
  // 7.15 Folge-Hygiene (31.05.2026): callcenter-Store haelt Wizard-Stand
  // (searchPerformed, currentStep, wizardData, recyclingCustomerId, ...)
  // und wurde bisher beim Logout nicht geraeumt. Nutzung der bestehenden
  // resetWizard-Methode des Stores.
  const { resetWizard: clearCallcenterState } = useCallcenterStore();

  const clearAllStates = () => {
    clearCustomersState();
    clearCustomerState();
    clearUsersState();
    clearNotificationsState();
    clearCallcenterState();
  };

  return {
    clearAllStates,
    clearCustomersState,
    clearUsersState,
    clearCustomerState,
    clearNotificationsState,
    clearCallcenterState,
  };
};

export default useClearState;
